import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-clients-view-button-renderer',
    template: `@if (!isRetrying && allowRetry()) {
  <button
    class="btn btn-sm btn-secondary"
    (click)="onClickRetry($safeNavigationMigration(params?.data?.id))">
    Retry ({{params?.data?.responseId}})
  </button>
}
@if (isRetrying) {
  <span>
    <i class="fa fa-spinner fa-spin"></i> Retrying...
  </span>
}
@if (!allowRetry()) {
  <strong>{{params?.data?.responseId}}</strong>
}`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewButtonRendererComponent implements AgRendererComponent {

  constructor() { }
  public params:any;
  public isRetrying: boolean = false;
  agInit(params:any):void {
      this.params = params;
  }
  public refresh(params:any):boolean
  {
    return true;
  }

  public allowRetry() {
    var allow: boolean = true;
    if(this.params.data){
      if(!this.params.data.apiCallTypeCanRetry)
        allow = false;
      if(this.params.data.retryId && this.params.data.retryId != 0)
        allow = false;
      if(this.params.data.responseId && this.params.data.responseId == 200)
        allow = false;
    }

    return allow;
  }

  public onClickRetry(positionId: number): void {
    this.isRetrying = true;
      this.params.context.componentParent.onClickRetry(positionId).pipe(
      finalize(() => {
        this.isRetrying = false; 
      })
    ).subscribe(
      () => {
      }
    );
  }
  

}
